(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 750;

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function setAccordionState() {
    var isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    document.querySelectorAll('.site-footer__accordion').forEach(function (details) {
      if (isMobile) {
        if (!details.dataset.userToggled) {
          details.removeAttribute('open');
        }
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  function bindToggleTracking() {
    document.querySelectorAll('.site-footer__accordion > summary').forEach(function (summary) {
      summary.addEventListener('click', function () {
        var details = summary.closest('.site-footer__accordion');
        if (window.innerWidth < MOBILE_BREAKPOINT && details) {
          details.dataset.userToggled = 'true';
        }
      });
    });
  }

  function init() {
    bindToggleTracking();
    setAccordionState();
    window.addEventListener('resize', debounce(setAccordionState, 200));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.site-footer__accordion')) {
      init();
    }
  });
})();